import React from 'react';
import { LibraryBigIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="bg-mist py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-155" data-mp="1iwcxjc03p0fu">
      <div className="mx-auto max-w-6xl px-4" data-id="element-156" data-mp="1dx9rbo8dwo6a">
        <div className="text-center" data-id="element-157" data-mp="1dudtdzwjdzhu">
          <span className="bg-ivory inline-flex items-center gap-2 rounded-sm border border-steel/30 px-4 py-2 font-mono text-[11px] font-bold uppercase tracking-[.18em] text-steel" data-id="element-158" data-mp="2bks89mc78wld">
            <LibraryBigIcon className="h-4 w-4" data-id="element-159" data-mp="21lsy1zbscsw9" /> Los {totalVolumes} tomos
          </span>
          <h2 id="modules-title" className="mx-auto mt-4 max-w-3xl text-balance text-3xl font-extrabold uppercase text-ink sm:text-4xl" data-id="element-160" data-mp="1wmzw945v2qbx">
            Una guía completa por cada dimensión de la Automatización Industrial
          </h2>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-161" data-mp="l71fsf8ct20o">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.12
          }} transition={{
            duration: 0.3,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="bg-ivory relative flex flex-col rounded-md border border-line p-6 text-ink shadow-card" data-id="element-162" data-mp="1nuldihq7d06j" data-mpi={index}>
                <span className="absolute inset-x-0 top-0 h-1 rounded-t-md bg-steel" aria-hidden="true" data-id="element-163" data-mp="14xk6ysh02s0h" />
                <div className="flex items-start justify-between gap-4" data-id="element-164" data-mp="q4gq6nb8giat">
                  <span className="flex h-11 w-11 items-center justify-center rounded-sm bg-petrolDark text-gold" data-id="element-165" data-mp="v6601zmpypxb">
                    <Icon className="h-6 w-6" data-id="element-166" data-mp="h6ofxxkdc0ua" />
                  </span>
                  <span className="font-mono text-xs font-bold uppercase tracking-[.16em] text-steel" data-id="element-167" data-mp="l66sa4y4j3li">Tomo {module.number}</span>
                </div>
                <h3 className="mt-5 text-lg font-extrabold uppercase leading-tight text-ink" data-id="element-168" data-mp="2j3f7eyaig46z">{module.title}</h3>
                <p className="mt-2 text-sm font-semibold text-gold" data-id="element-169" data-mp="2e42jsbbtet3c">{module.subtitle}</p>
                <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-170" data-mp="29599errtri7e">{module.description}</p>
                <p className="mt-4 flex-1 rounded-sm border-l-2 border-steel bg-steelSoft p-3 text-sm leading-relaxed text-deep" data-id="element-171" data-mp="36szr5jehn5hb">
                  <b className="font-extrabold uppercase" data-id="element-172" data-mp="31tn7t8mtsgjh">Resultado: </b>
                  {module.result}
                </p>
                <p className="mt-5 border-t border-line pt-4 font-mono text-[10px] font-semibold uppercase leading-relaxed tracking-[.08em] text-muted" data-id="element-173" data-mp="2wt8vvfi3smg6">
                  {module.tags}
                </p>
              </motion.article>;
        })}
        </div>

        <div className="bg-stage-deep bg-grid mt-8 flex flex-col items-center justify-between gap-4 rounded-md border border-gold/40 px-6 py-6 text-center sm:flex-row sm:text-left" data-id="element-174" data-mp="1hdtkus6pjlej">
          <p className="font-mono text-[11px] font-bold uppercase tracking-[.2em] text-gold" data-id="element-175" data-mp="x4d0gi3m1kx">Total de la colección principal</p>
          <p className="font-display text-2xl font-extrabold uppercase text-white sm:text-3xl" data-id="element-176" data-mp="5vnxsdkyh7bp">
            {totalVolumes} tomos <span className="mx-2 text-gold" data-id="element-177" data-mp="ap0f02nb2buf">·</span>
            <span className="text-base font-bold normal-case text-mutedDark sm:text-lg" data-id="element-178" data-mp="fn1tea9sdmzk">Contenido técnico y pedagógico actualizado 2026</span>
          </p>
        </div>
      </div>
    </section>;
}